import { FC } from "react";
import { Button, Modal } from "react-bootstrap";


const ImportantNoticeModal: FC<{ show: boolean; onHide: () => void; }> = (props): JSX.Element => {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="important-notice-modal-title"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="important-notice-modal-title">
          **Important Medicare Eligibility Verification Notice**
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          FlexForward is currently working through updated CMS HETS registration and
          attestation requirements impacting Medicare eligibility verification transactions.
        </p>
        <p>
          During this period, Medicare eligibility verification may be temporarily unavailable
          through our standard electronic verification process. While FlexForward continues
          working to restore full connectivity, provider offices may need to verify Medicare
          eligibility and benefits directly using their existing internal processes.
        </p>
        <p>
          Please note that FlexForward can continue supporting commercial and secondary
          coverage verification activities during this time.
        </p>
        <p>
          Our team is actively monitoring the situation and working closely with our technology and connectivity partners
          to minimize disruption to patient & provider support services.
        </p>
        <p>
          We appreciate your partnership and patience as the industry works through these
          CMS changes. Please contact our team with any questions at 1-844-353-9466.
        </p>
        <p className="m-0">
          For more information on HETS, please visit:{' '}
          <a href="https://www.cms.gov/data-research/cms-information-technology/hipaa-eligibility-transaction-system-hets/hets-edi-how-enroll" target="_blank" rel="noopener noreferrer">
            https://www.cms.gov/data-research/cms-information-technology/hipaa-eligibility-transaction-system-hets/hets-edi-how-enroll
          </a>
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={() => props?.onHide?.()}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ImportantNoticeModal;
